import axios from 'axios';
import { encrypt, decrypt } from '@/utils/crypto';
import { BASE_URL, TIMEOUT } from "./config";
import { Toast } from 'vant';
import { enableEncryption } from '@/utils/encryptionConfig';

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: TIMEOUT
});

instance.interceptors.request.use(config => {
  // 1.发送网络请求时, 在界面的中间位置显示Loading的组件
  Toast.loading({
    message: '加载中...',
    forbidClick: true,
    duration: 0,
  });

  // 2.某一些请求要求用户必须携带token, 如果没有携带, 那么直接跳转到登录页面

  // 3.请求数据加密
  if (enableEncryption && config.data && typeof config.data === 'object' && !(config.data instanceof FormData)) {
    try {
      // 将请求数据转为 JSON 字符串并加密
      const jsonStr = JSON.stringify(config.data);
      const encryptedData = encrypt(jsonStr);
      // 将加密后的数据包装成 JSON 对象，保持 Content-Type 为 application/json
      config.data = encryptedData;
      // 确保 Content-Type 为 application/json
      if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json';
      }
    } catch (error) {
      console.error('请求加密失败:', error);
    }
  }
  // 对于FormData，不加密，不设置Content-Type，让axios自动处理

  return config;
}, err => {
  return Promise.reject(err);
});

instance.interceptors.response.use(res => {
  // 响应数据解密
  if (enableEncryption && res.data) {
    try {
      // 判断响应数据是否为字符串（加密后的数据）
      if (typeof res.data === 'string') {
        // 解密响应数据
        const decryptedStr = decrypt(res.data);
        // 尝试解析为 JSON 对象
        try {
          res.data = JSON.parse(decryptedStr);
        } catch (parseError) {
          // 如果不是 JSON，直接返回解密后的字符串
          res.data = decryptedStr;
        }
      } else if (typeof res.data === 'object' && res.data.data) {
        // 如果响应数据是对象，且包含 data 字段，尝试解密 data 字段
        if (typeof res.data.data === 'string') {
          try {
            const decryptedStr = decrypt(res.data.data);
            res.data.data = JSON.parse(decryptedStr);
          } catch (error) {
            console.error('响应数据解密失败:', error);
          }
        }
      }
    } catch (error) {
      console.error('响应解密失败:', error);
      // 解密失败时返回原始数据
    }
  }
  Toast.clear();
  return res.data;
}, err => {
  if (err && err.response) {
    // 尝试解密错误响应
    if (enableEncryption && err.response.data && typeof err.response.data === 'string') {
      try {
        const decryptedStr = decrypt(err.response.data);
        err.response.data = JSON.parse(decryptedStr);
      } catch (error) {
        console.error('错误响应解密失败:', error);
      }
    }
    switch (err.response.status) {
      case 400:
        console.log("请求错误");
        break;
      case 401:
        console.log("未授权访问");
        break;
      default:
        console.log("其他错误信息");
    }
  }
  Toast.clear();
  return Promise.reject(err);
});

export default instance;

